// extracted by mini-css-extract-plugin
var _1 = "styles-module__link___B_w83";
export { _1 as "link" }
